import React from "react";
import { Table, Spinner, Form, Row, Col } from "react-bootstrap";
import TablePagination from "./TablePagination";
import "./pagination.css";

const DataTable = ({
  columns,
  data = [],
  loading,
  search,
  onSearch,
  showSearch = true,
  page,
  totalPages,
  onPageChange,
  showPagination = true,
  limit,
  onLimitChange,
  showLimit = true,
  renderRow,
}) => {
  return (
    <>
      {/* HEADER CONTROLS */}
      {(showSearch || showLimit) && (
        <Row className="mb-3 align-items-center">
          {showSearch && (
            <Col md={4}>
              <Form.Control
                placeholder="Search..."
                value={search}
                onChange={(e) => onSearch(e.target.value)}
              />
            </Col>
          )}

          {showLimit && (
            <Col md={2} className="ms-auto">
              <Form.Select
                value={limit}
                onChange={(e) => onLimitChange(Number(e.target.value))}
              >
                <option value="10">10 / page</option>
                <option value="25">25 / page</option>
                <option value="50">50 / page</option>
                <option value="100">100 / page</option>
              </Form.Select>
            </Col>
          )}
        </Row>
      )}

      {/* TABLE */}
      <Table bordered hover responsive>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                style={col.width ? { width: col.width } : undefined}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="text-center py-4">
                <Spinner animation="border" />
              </td>
            </tr>
          ) : data.length > 0 ? (
            data.map(renderRow)
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-4 text-muted"
              >
                {search ? (
                  <>
                    No results found for <strong>"{search}"</strong>
                  </>
                ) : (
                  "No data available."
                )}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* FOOTER PAGINATION */}
      {showPagination && totalPages > 1 && (
        <TablePagination
          page={page}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};

export default DataTable;
